if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getGiftAccessory(productId, variantId, quantity = 1) {
        if (!variantId) return [];
        if (window.merakiUtils?.getShopGiftAccessory) {
          const giftAccessoryItem = window.merakiUtils.getShopGiftAccessory({ productId, variantId, quantity });  
          if (giftAccessoryItem) {
            return giftAccessoryItem;
          }
        }
        return [];
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // delete config.headers['Content-Type'];
        config.headers['Content-Type'] = 'application/json';

        const params = {
          "items": []
        };

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);

          params['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
          params['sections_url'] = window.location.pathname;
        }

        this.getVariantData(params);

        const giftAccessoryItem = this.getGiftAccessory(formData.get('product-id'), formData.get('id'), formData.get('quantity'));
        if (giftAccessoryItem && giftAccessoryItem.length) {
          params.items.push(...giftAccessoryItem);
        }

        params.items.push({
          "id": formData.get('id'),
          "quantity": parseFloat(formData.get('quantity'))
        })

        // config.body = formData;
        config.body = JSON.stringify(params);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      getVariantData(params) {
        try {
          const productInfoNode = this.closest('product-info');
          if (productInfoNode) {
            const variantItemNodes = productInfoNode.querySelectorAll('.product-accessories-block .accessories-items .item');
            variantItemNodes.forEach((item) => {
              let defaultSelected = false;
              const productAccessoriesBlockNode = item.closest('.product-accessories-block');
              if (productAccessoriesBlockNode) {
                defaultSelected = productAccessoriesBlockNode.getAttribute('default-selected') === 'true';
              }
              if (defaultSelected) return;
              const isChecked = item.getAttribute('checked');
              if (isChecked !== null) {
                const variantOptionid = item.querySelector('.variant-option[checked]').getAttribute('data-option-value-id');
                const itemData = {
                  "id": variantOptionid,
                  "quantity": 1
                };
                params.items.push(itemData);
              }
            })
          }
        } catch (err) {
          console.log(err);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
